import React from 'react';
import { Modal, Empty } from 'antd';
import { BsListTask } from 'react-icons/bs';
import styles from './index.module.scss';

interface ActivityModalProps {
  visible: boolean;
  onCancel: () => void;
  activity: string | null;
  storyName?: string;
}

const ActivityModal: React.FC<ActivityModalProps> = ({
  visible,
  onCancel,
  activity,
  storyName,
}) => {
  const renderContent = () => {
    if (!activity || activity.trim() === '') {
      return (
        <div className={styles.emptyContainer}>
          <Empty
            image={<BsListTask size={48} className={styles.emptyIcon} />}
            description={
              <div className={styles.emptyDescription}>
                <h3>No Activity Available</h3>
                <p>This story doesn&apos;t have any activity content yet.</p>
              </div>
            }
          />
        </div>
      );
    }

    return (
      <div className={styles.activityContent}>
        <div className={styles.activityHeader}>
          <div className={styles.iconContainer}>
            <BsListTask size={24} className={styles.activityIcon} />
          </div>
          <h3>Story Activity</h3>
        </div>

        <div className={styles.activityBody}>
          <div className={styles.activityText}>
            {activity.split('\n').map((paragraph, index) => (
              <p key={index} className={styles.paragraph}>
                {paragraph.trim()}
              </p>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      className={styles.activityModal}
      centered>
      {renderContent()}
    </Modal>
  );
};

export default ActivityModal;
